import _ from 'lodash';

export const getSellingLotInformation = (lotsWon, paddle, currentLot) => {
  let soldLot = _.find(lotsWon, { id: _.get(currentLot, 'id', -1) });
  if (soldLot) {
    return { ...soldLot, soldToMe: soldLot.paddle === paddle };
  }
  return null;
};
